import { Form, InputGroup as InputGroupC } from "react-bootstrap";
import CurrencyInput from "react-currency-input-field";

export function InputGroupNumber({
  label,
  name,
  onChangeMethod,
  onBlurMethod,
  value,
  error,
  touched,
  disabled,
  decimals,
  negatives,
  prefix,
  suffix,
  placeholder,
  disableSep,
  decimalsLimit = 2,
  maxLength,
  required,
  left,
  right,
}: {
  label: string;
  name: string;
  onChangeMethod: any;
  onBlurMethod: any;
  value: string;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  decimals?: boolean;
  negatives?: boolean;
  prefix?: string;
  suffix?: string;
  placeholder?: string;
  disableSep?: boolean;
  decimalsLimit?: number;
  maxLength?: number;
  required?: boolean;
  left?: any;
  right?: any;
}) {
  return (
    <>
      <Form.Group className="mb-3 position-relative">
        {label && (
          <Form.Label htmlFor={name}>
            {label} {required && <span className="text-danger">*</span>}
          </Form.Label>
        )}
        <InputGroupC>
          {left && (
            <InputGroupC.Text className="rounded-start">
              <div className=" max-group">{left}</div>
            </InputGroupC.Text>
          )}
          <CurrencyInput
            id={name}
            name={name}
            className={
              "form-control" +
              (error !== undefined && touched !== undefined
                ? " is-invalid"
                : "")
            }
            allowDecimals={decimals ? true : false}
            decimalsLimit={decimalsLimit}
            decimalScale={decimals ? (+value % 1 === 0 ? 0 : 2) : undefined}
            allowNegativeValue={negatives ? true : false}
            onValueChange={(value: any, name?: string) =>
              onChangeMethod({ target: { name: name, value: value } })
            }
            onBlur={onBlurMethod}
            value={value}
            prefix={prefix ? prefix : undefined}
            suffix={suffix ? suffix : undefined}
            groupSeparator=","
            decimalSeparator="."
            disabled={disabled ? true : false}
            disableGroupSeparators={disableSep ? true : false}
            placeholder={placeholder ? placeholder : undefined}
            maxLength={maxLength || 18}
          />
          {right && (
            <InputGroupC.Text className="rounded-end max-group">
              {right}
            </InputGroupC.Text>
          )}
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </InputGroupC>
      </Form.Group>
    </>
  );
}